import React from 'react';

const EventSummaryCard = ({ event }) => {
  if (!event) return null;

  return (
    <div className="ticket-card">
      <div className="ticket-event-header ticket-event-header--title-only">
        <h2 className="ticket-event-header__title ticket-event-header__title--large">
          {event.name}
        </h2>
      </div>
      <div className="ticket-event-info-grid">
        <div className="ticket-event-info-item">
          <span>📅</span>
          <span>
            <strong>Date:</strong> {event.formattedDate}
          </span>
        </div>
        <div className="ticket-event-info-item">
          <span>🕰️</span>
          <span>
            <strong>Time:</strong> {event.formattedTime}
          </span>
        </div>
        <div className="ticket-event-info-item">
          <span>📍</span>
          <span>
            <strong>Location:</strong> {event.location || 'TBA'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EventSummaryCard;
